import Vue from  'vue'

export default {

    created()
    {
        this.eventHub.$on('popin:subscribe:open', this.open)
        // this.eventHub.$on('popin:subscribe:close', this.close)
    },

    data()
    {
    	return {
            subscribeUrl: '/api/subscribe.php',
    		isOpen: false,
            message: '',
            error: false,
            success: false
    	}
    },

    methods: {

    	open()
        {
    		this.isOpen = true

            this.message = ''
            this.error = false
            this.success = false
            // setTimeout( this.$root.$children[0].removeScrollbar.bind(this), 1000 )
    	},

        close()
        {
            this.isOpen = false
            // this.$root.$children[0].deliverScrollbar()
        },

        _errorList( id, email )
        {
            return [
                '',
                `An error as occurred, please check the validity of your email (${email}) or send a message to the administrator.`,
                'This email is already added.',
                'An error as occurred, please retry or send a message to the administrator.',
            ][id]
        },

        _displaySuccess()
        {
            this.error = false
            this.success = true
            this.message = 'Your email has been added to the newsletter list and you will be informed when the book is ready for purchase.'
            // this.close()
            // console.log('success')
        },

        _displayError( message )
        {
            this.error = true
            this.message = message
        },

        _formSuccess( data )
        {
            if (data)
            {
                if (data.error > 0)
                {
                    console.error('Subscribe server error:', data.detail)
                    const message = this._errorList(parseInt(data.error), this.email)

                    this._displayError(message)
                }
                else
                {
                    this._displaySuccess()
                }
            }
            else
            {
                console.error('Subscribe body error: ', event)
                const message = this._errorList(3, '')
                this._displayError(message)
            }
        },

        _formError( data )
        {
            console.error('_formError', data)
            const msg = this._errorList(3, this.email)
            this._displayError(msg)
        },

        _submitForm( event )
        {
            const email = event.target[0].value
            event.target.reset()
            this.message = ''
            this.email = email

            window.fetch('/api/subscribe.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: 'email=' + encodeURIComponent(email)
                })
                .then(res => res.json())
                .then(this._formSuccess)
                .catch(this._formError)

            // return false
        }
    }
}
